"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-incarico": {
    "0f6a5b03": [{
      "hkey": "74341e81",
      "slug": "colletronco",
      "name": "Colletronco",
      "primary": true,
      "skipSearch": false
    }],
    "colle-tronco": [{
      "hkey": "74341e81",
      "slug": "colletronco",
      "name": "Colletronco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4ef3e1a7": [{
      "hkey": "a06657e2",
      "slug": "san-giovanni-incarico",
      "name": "San Giovanni Incarico",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-della-selva": [{
      "hkey": "a06657e2",
      "slug": "san-giovanni-incarico",
      "name": "San Giovanni Incarico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;